export const clientListStyle = (template) => {
  if (template && template.interaction.clientList) {
    const obj = template.interaction.clientList;
    const frame = obj.frame;
    const avatar = obj.avatar;
    const header = obj.header;
    const searchbar = obj.searchBar;
    const list = obj.list;
    const listItem = obj.listItem;
    const name = obj.listItem.name;
    const company = obj.listItem.company;
    return {
      frame: {
        /*  background: header.background != "unset" ? header.background : "#fff", */
        borderColor: frame.borderColor != "unset" ? frame.borderColor : "unset",
        borderWidth: frame.borderWidth != "unset" ? frame.borderWidth : "0px",
        borderRadius: frame.borderRadius != "unset" ? frame.borderRadius : "0px",
        boxShadow: "none",
        borderStyle: "solid",
      },
      avatar: {
        background: avatar.background != "unset" ? avatar.background : "#red",
        color: avatar.color != "unset" ? avatar.color : "#fff",
        borderRadius: avatar.borderRadius != "unset" ? avatar.borderRadius : "50%",
      },
      header: {
        background: header.background != "unset" ? header.background : "#fff",
        fontSize: header.fontSize != "unset" ? header.fontSize : "18px",
        color: header.color != "unset" ? header.color : "#222",
        fontWeight: header.fontWeight != "unset" ? header.fontWeight : "normal",
        fontFamily: header.fontFamily != "unset" ? header.fontFamily : "Open Sans",
      },
      list: {
        background: list.background != "unset" ? list.background : "#fff",
      },
      searchbar: {
        iconColor: searchbar.iconColor != "unset" ? searchbar.iconColor : "#222",
        background: searchbar.background != "unset" ? searchbar.background : "#fff",
        borderRadius: searchbar.borderRadius != "unset" ? searchbar.borderRadius : "0px",
        fontSize: searchbar.fontSize != "unset" ? searchbar.fontSize : "18px",
        color: searchbar.color != "unset" ? searchbar.color : "#222",
        fontWeight: searchbar.fontWeight != "unset" ? searchbar.fontWeight : "normal",
        fontFamily: searchbar.fontFamily != "unset" ? searchbar.fontFamily : "Open Sans",
        boxShadow: "none",
        margin: searchbar.margin != "unset" ? searchbar.margin : "0px",
        borderWidth: searchbar.borderWidth != "unset" ? searchbar.borderWidth : "0px",
        borderColor: searchbar.borderColor != "unset" ? searchbar.borderColor : "unset",
        width: searchbar.width != "unset" ? searchbar.width : "100%",
        border: 0,
        borderBottom: `${searchbar.borderWidth} solid ${searchbar.borderColor}`,
        borderTop: `${searchbar.borderWidth} solid ${searchbar.borderColor}`,
      },
      listItem: {
        background: listItem.background != "unset" ? listItem.background : "#fff",
        borderRadius: listItem.borderRadius != "unset" ? listItem.borderRadius : "0px",
        boxShadow: "none",
        borderWidth: listItem.borderWidth != "unset" ? listItem.borderWidth : "0px",
        borderColor: listItem.borderColor != "unset" ? listItem.borderColor : "unset",
        width: listItem.width != "unset" ? listItem.width : "100%",
        border: 0,
        margin: listItem.margin != "unset" ? listItem.margin : "0px auto",
        borderBottom: `${listItem.borderWidth} solid ${listItem.borderColor}`,
        /*    width: listItem.width != "unset" ? listItem.width : "100%", */
        name: {
          fontSize: name.fontSize != "unset" ? name.fontSize : "15px",
          color: name.color != "unset" ? name.color : "#222",
          fontWeight: name.fontWeight != "unset" ? name.fontWeight : "normal",
          fontFamily: name.fontFamily != "unset" ? name.fontFamily : "Open Sans",
        },
        company: {
          fontSize: company.fontSize != "unset" ? company.fontSize : "15px",
          color: company.color != "unset" ? company.color : "#222",
          fontWeight: company.fontWeight != "unset" ? company.fontWeight : "normal",
          fontFamily: company.fontFamily != "unset" ? company.fontFamily : "Open Sans",
        },
      },
    };
  } else {
    //Fix
  }
};

export const backstageListStyle = {
  frame: {
    background: "#333333",
    borderColor: "unset",
    borderWidth: "0px",
    borderRadius: "0px",
    boxShadow: "none",
    borderStyle: "solid",
  },
  avatar: {
    background: "rgb(105 105 105)",
    color: "#fff",
    borderRadius: "50%",
  },
  header: {
    background: "#333333",
    fontSize: "1.1rem",
    color: "#eee",
    fontWeight: "normal",
    fontFamily: "Open Sans",
  },
  list: {
    background: "#333333",
  },
  searchbar: {
    iconColor: "#eee",
    background: "#4b4b4b",
    borderRadius: "25px",
    fontSize: "1rem",
    color: "#eee",
    fontWeight: "normal",
    fontFamily: "Open Sans",
    boxShadow: "none",
    margin: "0px",
    borderWidth: "0px",
    borderColor: "unset",
    width: "95%",
    border: 0,
    borderBottom: 0,
    borderTop: 0,
  },
  listItem: {
    background: "#333333",
    borderRadius: "0px",
    boxShadow: "none",
    borderWidth: "0px",
    borderColor: "unset",
    width: "100%",
    border: 0,
    margin: "0px auto",
    borderBottom: 0,
    name: {
      fontSize: "1rem",
      color: "#fff",
      fontWeight: "normal",
      fontFamily: "Open Sans",
    },
    company: {
      fontSize: "1rem",
      color: "#eee",
      fontWeight: "normal",
      fontFamily: "Open Sans",
    },
  },
};
